import * as React from "react";

import ShopifyThemeEditor from "@svg/billing/ShopifyThemeEditor";

import MetricBox from "./MetricBox";
import ProductCard from "./ProductCard";
import UsageRow from "./UsageRow";

type ShopifyThemeBuilderUsageSummaryCardProps = {
  currentProjects: number;
  maximumProjects: number | null;
  currentPublishedItems: number;
  maximumPublishedItems: number | null;
};

const ShopifyThemeBuilderUsageSummaryCard = ({
  currentProjects,
  maximumProjects,
  currentPublishedItems,
  maximumPublishedItems,
}: ShopifyThemeBuilderUsageSummaryCardProps) => {
  return (
    <ProductCard icon={<ShopifyThemeEditor />} title="Shopify Theme Builder">
      <UsageRow
        title="Active Projects"
        description="Shopify Theme Builder projects that have at least one published item."
      >
        <MetricBox
          label="Active Projects"
          current={currentProjects}
          maximum={maximumProjects}
          // TODO (Andrew, 2026-01-30, REPL-18539): Add back when plan change modal is added
          // buttonLabel={modifiableTier ? "Add Projects" : undefined}
          // onButtonClick={modifiableTier ? handleAddProjects : undefined}
        />
      </UsageRow>
      <UsageRow
        title="Published Items on Shopify"
        description="Shopify Theme Builder pages and sections that are currently published."
        hasBorderBottom={false}
      >
        <MetricBox
          label="Total Published Items on Shopify"
          current={currentPublishedItems}
          maximum={maximumPublishedItems}
          // TODO (Andrew, 2026-01-30, REPL-18539): Add back when plan change modal is added
          // buttonLabel={modifiableTier ? "Add Published Items" : undefined}
          // onButtonClick={modifiableTier ? handleAddPublishedItems : undefined}
        />
      </UsageRow>
    </ProductCard>
  );
};

export default ShopifyThemeBuilderUsageSummaryCard;
